import { render, staticRenderFns } from "./FundCitiationEditable.vue?vue&type=template&id=ba4dc712"
import script from "./FundCitiationEditable.vue?vue&type=script&lang=js"
export * from "./FundCitiationEditable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports